<template>
  <Body class="page-home" />
  <!-- 안내 팝업 -->
  <!-- <NoticeAward /> -->
  <Notice />

  <!-- Section : 상단 비주얼 -->
  <section class="section-welcome">
    <div class="headline flex-center flex-column">
      <h1>
        <RibbonLottie />
        <!-- <img
          class="img"
          src="/images/about_1_tit.svg"
          alt="‘어머니 사랑과 평화의 날’ & UN ‘국제 관용의 날’ 기념 캠페인"
        /> -->
        <span class="blind">‘어머니 사랑과 평화의 날’ & UN ‘국제 관용의 날’ 기념 캠페인</span>
      </h1>
      <h2 v-if="locale === 'ko'">
        <img class="img" src="/images/headline_welcome_new.svg" alt="평화를 부르는 ‘어머니 사랑의 언어’">
        <span class="blind">평화를 부르는 ‘어머니 사랑의 언어’</span>
      </h2>
      <!-- 다국어용 : 한국어 외에는 텍스트로 들어가요 -->
      <h2 v-else v-html="$t('2024br평화를부르는br어머니사랑의언어')" />
      <p
        v-html="$t('이해와배려가담긴따뜻한말br어머니사랑의언어로소통해보세요br어머니사랑이닿는곳에평화가깃듭니다')"
      />
      <div class="btn-wrap">
        <!-- <div class="date">{{ $t('집중실천기간') }} {{ $t('20241111231') }}</div> -->
        <NuxtLink :to="$localePath('/about')" class="btn-color">
          {{ $t('캠페인소개') }}
        </NuxtLink>
      </div>

      <div class="flower flower-left">
        <div class="left1 ani" />
        <div class="left2 ani" />
        <div class="left3 ani" />
        <div class="left4 ani" />
        <div class="left5 ani" />
        <div class="left6 ani" />
        <div class="left7 ani" />
        <div class="left8 ani" />
      </div>

      <div class="flower flower-right">
        <div class="right1 ani" />
        <div class="right2 ani" />
        <div class="right3 ani" />
        <div class="right4 ani" />
        <div class="right5 ani" />
        <div class="right6 ani" />
      </div>
    </div>

    <div class="visual-animaiton">
      <ClientOnly>
        <Vue3Lottie :animation-data="visualJSON" :speed="1" :loop="true" :auto-play="true" />
      </ClientOnly>
    </div>
  </section>

  <!-- Section : 202506 가족사랑 실천 공모전 -->
  <!--
  <section class="section-contest familylove">
    <div class="inner">
      <div class="titlewrap">
        <div class="sub">
          {{ $t('2026가정의달5월un국제가정의날515기념') }}
        </div>
        <h1 class="title" v-html="$t('평화를부르는br어머니사랑의언어brspan가족사랑실천공모전span')"></h1>
        <div class="desc"
          v-html="`
            ${$t('가족에게차마전하지못한진심이있나요')} <br>
            ${$t('사랑하지만표현이서툴렀던마음br고맙고미안하지만건네지못했던한마디')} <br>
            ${$t('지금어머니사랑의언어로진심을전해보세요')} <br>
            ${$t('어머니사랑이닿는곳에평화가깃듭니다')}
          `"
        />
        <NuxtLink :to="$localePath('/contest-familylove')" class="btn-color">
          {{ $t('바로가기') }}
        </NuxtLink>
      </div>
    </div>
  </section>
  -->

  <!-- Section : 뉴스 -->
  <section v-if="latestNews.length > 0" class="sections list news">
    <div class="container">
      <div class="headline">
        <div class="txtwrap">
          <div class="txt">
            <h3 class="tit">
              {{ $t('주요소식') }}
            </h3>
            <p v-html="$t('메인_뉴스_설명')" />
          </div>
        </div>
        <NuxtLink :to="$localePath('/news')" class="link">
          {{ $t('바로가기') }}
        </NuxtLink>
      </div>

      <ul class="lists list-news-latest">
        <li v-for="news in latestNews" :key="news.id" class="list-item">
          <NuxtLink :to="$localePath(`/news/${news.id}`)" class="list-link">
            <div class="thum" :class="{ default: news.thumbnailUrl == null }">
              <div
                class="thum-img"
                :style="{ backgroundImage: `url(${news.thumbnailUrl ?? defaultThumbnail})` }"
              />
            </div>
            <div class="info">
              <div class="post-title" v-html="news.title" />
              <div class="post-excerpt" v-html="news.contents" />
              <div class="date">
                {{ formatIntlDate(new Date(news.createdAt), locale) }}
              </div>
            </div>
          </NuxtLink>
        </li>
      </ul>
    </div>
  </section>

  <!-- Section : 캠페인 영상 -->
  <MainVideoSection v-if="locale === 'ko'" />

  <!-- Section : 2주년 기념 : 1년의 이야기 -->
  <section class="section-anniversary2nd">
    <div class="inner">
      <div class="titlewrap">
        <div class="deco-wrap">
          <div class="deco-ribbon">
            {{ $t('스페셜') }}
          </div>
        </div>
        <h2 class="title" v-html="$t('어머니사랑의언어brspan1년의이야기span')" />
        <div class="desc">
          {{ $t('어머니사랑이꽃피워낸사랑가득한1년의이야기') }}
        </div>
        <NuxtLink :to="$localePath('/special/anniversary2nd')" class="btn-color">
          {{ $t('바로가기') }}
        </NuxtLink>
      </div>

      <div class="circles circle-orange" />
      <div class="circles circle-pink" />
    </div>
  </section>

  <!-- Section : 202505 편지 후기 공모전 -->
  <section v-if="isContestOngoing(locale)" class="section-contest hidden">
    <div class="inner">
      <div class="titlewrap">
        <div class="sub">
          {{ $t('2025년5월') }}
        </div>
        <h1 class="title" v-html="$t('평화를부르는br‘어머니사랑의언어’br편지후기공모전')" />
        <div
          class="desc"
          v-html="$t('사랑과감사의마음을전하는5월소중한이들에게br어머니사랑의언어로마음을담아편지를전해보세요')"
        />
        <NuxtLink :to="$localePath('/contest')" class="btn-color">
          {{ $t('바로가기') }}
        </NuxtLink>
      </div>
    </div>
  </section>

  <!-- Section : 참여 현황 -->
  <section class="section-statistics">
    <div class="inner">
      <div class="titlewrap">
        <div class="section-name">
          {{ $t('참여현황') }}
        </div>
        <h3 class="title">
          {{ $t('평화를부르는사람들') }}
        </h3>
        <div
          class="desc"
          v-html="
            $t('어머니사랑을품은한사람의작은실천은세상을변화시키는시작이자인류가평화로나아가는첫걸음입니다br지금함')
          "
        />
        <NuxtLink :to="$localePath('/status')" class="btn-line">
          {{ $t('바로가기') }}
        </NuxtLink>
      </div>
      <div class="participation">
        <div class="item">
          <div class="tit">
            {{ $t('국가') }}
          </div>
          <div class="count">
            {{ formatNumber(data?.engagementStatistics.countryCount ?? 0, locale) }}
          </div>
        </div>
        <div class="item">
          <div class="tit">
            {{ $t('참여인원') }}
          </div>
          <div class="count">
            {{ formatNumber(data?.engagementStatistics.userCount ?? 0, locale) }}
          </div>
        </div>
        <div class="item">
          <div class="tit">
            {{ $t('횟수') }}
          </div>
          <div class="count">
            {{ formatNumber(data?.engagementStatistics.engagementCount ?? 0, locale) }}
          </div>
        </div>
      </div>
      <div class="titlewrap">
        <div class="base">
          ({{ $t('연인원기준') }})
        </div>
      </div>

      <!-- 데일리체크 -->
      <div class="dailychecks">
        <div class="textbox">
          <div class="tit" v-html="$t('b데일리b체크')" />
          <div class="desc" v-html="$t('오늘하루b어머니사랑의언어b로brclassbrnone어떤평화를이루셨나요')" />
          <NuxtLink :to="$localePath('/checklist')" class="btn-color">
            {{ $t('바로가기') }}
          </NuxtLink>
        </div>
      </div>
    </div>
  </section>

  <!-- Section : 지지서명 / 다운로드 배너 -->
  <section class="sections bannerwrap">
    <div class="container">
      <div class="banner banner-ico banner-sign">
        <div class="txtwrap">
          <div class="tit">
            {{ $t('지지서명') }}
          </div>
          <p v-html="$t('작은실천이모여세상을변화시킬수있도록br아낌없는지지를보내주세요')" />
          <NuxtLink :to="$localePath('/signature')" class="banner-btn">
            {{ $t('바로가기') }}
          </NuxtLink>
        </div>
      </div>

      <div class="banner banner-ico banner-down">
        <div class="txtwrap">
          <div class="tit" v-html="$t('b카드b다운로드')" />
          <p v-html="$t('가족이웃지인이생각날때br마음을담아문자와함께보내보세요')" />
          <NuxtLink :to="$localePath('/download')" class="banner-btn">
            {{ $t('바로가기') }}
          </NuxtLink>
        </div>
      </div>
    </div>
  </section>

  <!-- Section : 후기 -->
  <section v-if="data?.reviews && data.reviews.length > 0" class="sections list review">
    <div class="container">
      <div class="headline">
        <div class="txtwrap">
          <div class="txt">
            <h3 class="tit">
              {{ $t('후기') }}
            </h3>
            <p v-html="$t('가족이웃등주위에캠페인을실천하며일어난br따뜻한에피소드를만나보세요')" />
          </div>
        </div>
        <NuxtLink :to="$localePath('/review')" class="link">
          {{ $t('바로가기') }}
        </NuxtLink>
      </div>

      <div class="wrap">
        <ul class="lists list-lateral list-review">
          <ReviewListItem v-for="review in data.reviews" :key="review.id" :review="review" :my="false" />
        </ul>
      </div>
    </div>
  </section>

  <!-- Section : 언론보도 -->
  <section class="sections list press">
    <div class="container">
      <div class="headline">
        <div class="txtwrap">
          <div class="txt">
            <h3 class="tit">
              {{ $t('언론보도') }}
            </h3>
            <p v-html="$t('세상을바꾸는따뜻한실천br언론에소개된어머니사랑과평화의날캠페인소식을만나보세요')" />
          </div>
        </div>
        <NuxtLink :to="$localePath('/press')" class="link">
          {{ $t('바로가기') }}
        </NuxtLink>
      </div>

      <div class="wrap">
        <ul class="lists list-press">
          <li v-for="(news, index) in newsList" :key="`news-${index}`" class="list-item">
            <NuxtLink :to="news.link" class="item list-link">
              <div class="texts">
                <div class="the-press" v-html="news.media" />
                <div class="post-title" v-html="news.title" />
                <div class="info">
                  <div class="country">
                    <span class="flag" style="background-image:url('https://pic.watv.org/imgFlag/flag-kr.gif')" />
                    <span class="country-name" v-html="formatIntlCountry(news.country, locale)" />
                  </div>
                  <div class="date" v-html="formatIntlDate(new Date(news.date), locale) " />
                </div>
              </div>
            </NuxtLink>
          </li>
        </ul>
      </div>
    </div>
  </section>

  <!-- Section : 모바일 앱 다운로드 -->
  <section v-if="!isWebview" class="banner-app">
    <div class="container flex-center flex-column textwrap">
      <img class="img appicon" src="/images/banner_mobileApp_01.svg" alt="어머니 사랑과 평화의 날 사이트 앱 아이콘">
      <div class="text">
        <h3 class="title">
          {{ $t('모바일앱에서더욱편리하게') }}
        </h3>
        <p v-html="$t('모바일에최적화된로그인환경과편리함을경험해보세요brclassbrnone버튼을클릭하시면스토어로이')" />
      </div>
      <div class="btnwrap">
        <a href="https://play.google.com/store/apps/details?id=org.watv.heavenlymotherslove" class="btn btn-google">Google Play</a>
        <a href="https://apps.apple.com/app/어머니-사랑과-평화의-날-캠페인/id6738273981" class="btn btn-apple">App Store</a>
      </div>
    </div>

    <picture class="img">
      <source media="(max-width:767px)" srcset="/images/banner_mobileApp_04_m.svg">
      <img src="/images/banner_mobileApp_04.svg" alt="">
    </picture>
  </section>
</template>

<script lang="ts" setup>
import type { HmlHomeScreenDataModel } from '~/types/models/models'
// GSAP ----------
import gsap from 'gsap'
// lottie ----------
import { Vue3Lottie } from 'vue3-lottie'

import visualJSON from '@/assets/lotties/visual.json'
import useWebviewBridge from '~/composables/useWebviewBridge'

const { $t } = useNuxtApp()

// Head,Body
useHead({
  title: $t('어머니사랑과평화의날캠페인'),
  link: [{ rel: 'stylesheet', href: `/css/home.css?${useBuildTime()}` }],

})

const { locale } = useI18n()

// 모바일카드/포스터 이전다음장 ----------
const { isWebview } = useWebviewBridge()

// 뉴스 최신 4건
const { defaultThumbnail } = useReview()
const { data: newsData } = await useFetch<{
  news: { id: number, thumbnailUrl: string | null, title: string, contents: string, createdAt: string }[]
  total: number
}>('/api/news', {
  method: 'GET',
  query: { languageGbSn: locale.value, page: 1, pageSize: 4 },
})
const latestNews = computed(() => newsData.value?.news ?? [])

const { data } = await useAPI<HmlHomeScreenDataModel>('/hml/v1/screens/home', {
  method: 'GET',
  query: {
    languageGbSn: useI18n().locale,
  },
})

onMounted(() => {
  // 타임라인 생성
  const tl1 = gsap.timeline()
  tl1.add('title-start')

  // 서브 타이틀 애니메이션 추가
  tl1.from(
    '.section-intro .subtit',
    {
      opacity: 0,
      y: 20,
      duration: 0.8,
      ease: 'power1.out',
    },
    'title-start',
  )

  // 타이틀 애니메이션 추가
  tl1.from(
    '.section-intro .title',
    {
      opacity: 0,
      y: 30,
      duration: 1,
      ease: 'power1.out',
    },
    'title-start+=0.2',
  )

  // 설명 문구 애니메이션과 꽃 애니메이션을 동시에 시작
  tl1.from(
    '.section-intro .text p',
    {
      opacity: 0,
      y: 30,
      duration: 0.8,
      ease: 'power1.out',
      stagger: 0.2,
    },
    'title-start+=0.4',
  )

  // 왼쪽 꽃 애니메이션 (역순 적용, 텍스트와 함께 시작)
  tl1.staggerFrom(
    gsap.utils.toArray('.flower-left .ani').reverse(), // 왼쪽 꽃을 역순으로 선택
    1.5,
    {
      opacity: 0,
      scale: 0,
      x: 30,
      ease: 'elastic.out(1, 0.5)',
    },
    0.08,
    'title-start', // 설명 문구와 같은 타이밍에 시작
  )

  // 오른쪽 꽃 애니메이션 (왼쪽 꽃과 함께 시작)
  tl1.staggerFrom(
    '.flower-right .ani',
    1.5,
    {
      opacity: 0,
      scale: 0,
      x: -30,
      ease: 'elastic.out(1, 0.5)',
    },
    0.08,
    'title-start+=0.6', // 왼쪽 꽃과 거의 동시에 시작되도록 조정
  )
})

const newsList = [
  {
    date: '2026-01-28',
    media: $t('전남일보'),
    title: $t('어머니사랑담긴언어로세상에평화전해요'),
    country: 'KR',
    link: 'https://www.jnilbo.com/news/articleView.html?idxno=90000021254',
  },
  {
    date: '2026-01-28',
    media: $t('경북신문'),
    title: $t('경북경산서평화를부르는어머니사랑의언어세미나열어'),
    country: 'KR',
    link: 'https://www.kbsm.net/news/view.php?idx=506506',
  },
  {
    date: '2026-01-27',
    media: $t('대전일보'),
    title: $t('고마워요잘하고있어요대전서울려퍼진어머니사랑의기적'),
    country: 'KR',
    link: 'https://www.daejonilbo.com/news/articleView.html?idxno=2253462',
  },
  {
    date: '2026-01-20',
    media: $t('서울경제'),
    title: $t('하나님의교회어머니사랑의언어세미나성황'),
    country: 'KR',
    link: 'https://m.sedaily.com/article/14172971',
  },
  {
    date: '2026-01-19',
    media: $t('매일경제'),
    title: $t('엄마는네편이야어머니사랑의언어세미나인기'),
    country: 'KR',
    link: 'https://www.mk.co.kr/news/culture/11936899',
  },
  // {
  //   date:'2025-11-21',
  //   media:$t('주간동아'),
  //   title:$t('어머니사랑깃든언어로세상을따뜻하게'),
  //   country:'KR',
  //   link: "https://weekly.donga.com/culture/article/all/11/5973151/1"
  // },
  // {
  //   date:'2025-07-18',
  //   media:$t('월간중앙'),
  //   title:$t('ai에인간존중가치불어넣자국제봉사단체asezai시대의어머니마음포럼개최'),
  //   country:'KR',
  //   link: "https://www.m-joongang.com/news/articleView.html?idxno=401379"
  // },
  // {
  //   date:'2025-04-15',
  //   media:$t('문화일보'),
  //   title:$t('내가미안해힘들었지말한마디에행복찾아와'),
  //   country:'KR',
  //   link: "https://www.munhwa.com/article/11498955?ref=naver"
  // }
]
</script>
